import { Link } from "react-router-dom";
import type { Category } from "@/lib/news";

interface CategoryHeaderProps {
  category: Category;
}

export default function CategoryHeader({ category }: CategoryHeaderProps) {
  return (
    <div className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-8 md:px-6 md:py-10">
        <nav className="flex flex-wrap items-center gap-2 text-xs text-foreground-500" aria-label="面包屑导航">
          <Link to="/" className="transition-colors hover:text-primary-600 cursor-pointer">
            首页
          </Link>
          <i className="ri-arrow-right-s-line text-foreground-300" />
          <span>黑料分类</span>
          <i className="ri-arrow-right-s-line text-foreground-300" />
          <span className="text-foreground-800">{category.name}</span>
        </nav>

        <div className="mt-5 flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className={`${category.icon} text-2xl`} />
          </span>
          <div>
            <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {category.name}
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-600">
              {category.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}